module.exports = __webpack_public_path__ + "static/media/groups.325432d3.svg";